@if (mifForm) {
  <form [formGroup]="mifForm" class="hide-in-pdf">
    <div class="mt-4">
      <div class="card">
        <div class="row">
          <div class="col-12 text-left">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  @if (!isContract) {
                    <h5 class="header mt-3">{{ 'SUMMARY.FormReferer' | labelText }}</h5>
                  } @else {
                    <h5 class="header mt-3">{{ 'SUMMARY.FormRefererInCaseMember' | labelText }}</h5>
                  }
                </div>
              </div>

              <app-view-offer
                [clientProfile]="clientProfileForViewOffer"
                [pageName]="constants.pages.summary.name"
                [firstPage]="true"
                [manualOverrideOffer]="manualOverrideOffer"
                (onOffersItem)="onOffersItem($event)"
                (onOffersItems)="onOffersItems($event)"
              ></app-view-offer>

              <div class="row" [ngClass]="{ hidden: isContract }">
                <div class="col-xs-12 col-sm-9 col-md-9 col-lg-6">
                  <app-dropdown-form-control
                    [parentForm]="mifForm"
                    [formControlName]="'advertisementSourceCode'"
                    [title]="'SUMMARY.FormReferer' | labelText"
                    (onChanged)="onSourceChange($event)"
                  >
                  </app-dropdown-form-control>
                </div>
              </div>

              @if (source === sources.PARRAINAGE) {
                <div class="row">
                  <div class="col-xs-12 col-sm-9 col-md-9 col-lg-6">
                    <app-number-form-control
                      [parentForm]="mifForm"
                      [formControlName]="'sponsorNumber'"
                      [title]="'SUMMARY.SponsorNumberTitle' | labelText"
                    >
                    </app-number-form-control>
                  </div>
                </div>
              }

              @if (source === sources.PARTENAIRE) {
                <div class="row">
                  <div class="col-xs-12 col-sm-9 col-md-9 col-lg-6">
                    <app-number-form-control
                      [parentForm]="mifForm"
                      [formControlName]="'partnerCode'"
                      [title]="'SUMMARY.PartnerCode' | labelText"
                    >
                    </app-number-form-control>
                  </div>
                </div>
              }

              @if (source === sources.MEMBRE_CORRESPONDANT) {
                <div class="row">
                  <div class="col-xs-12 col-sm-9 col-md-9 col-lg-6">
                    <app-number-form-control
                      [parentForm]="mifForm"
                      [formControlName]="'memberNumber'"
                      [title]="'SUMMARY.MemberNumberTitle' | labelText"
                    >
                    </app-number-form-control>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xs-12 col-sm-9 col-md-9 col-lg-3">
                    <app-name-form-control
                      [parentForm]="mifForm"
                      [formControlName]="'lastName'"
                      [title]="'SUMMARY.MemberFullNameTitle' | labelText"
                    >
                    </app-name-form-control>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                    <app-name-form-control [parentForm]="mifForm" [formControlName]="'firstName'" [title]="''">
                    </app-name-form-control>
                  </div>
                </div>
              }

              <div class="row">
                <div class="col-xs-12 col-sm-9 col-md-9 col-lg-6">
                  <app-name-with-digits-form-control
                    [parentForm]="mifForm"
                    [formControlName]="'promoCode'"
                    [title]="'SUMMARY.CodePromoTitle' | labelText"
                  >
                  </app-name-with-digits-form-control>
                </div>
              </div>

              @if (advertisementSourceCodeControl?.value !== sources.MEMBRE_CORRESPONDANT) {
                <div class="row mt-4">
                  <div class="col-xs-12 col-sm-10 col-md-7 col-lg-7">
                    {{ 'SUMMARY.FormAdvisorCode' | labelText }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-xs-12 col-sm-9 col-md-6 col-lg-3">
                    <app-number-form-control
                      class="no-title"
                      [parentForm]="mifForm"
                      [formControlName]="'mifAdvisorCode'"
                      [title]="''"
                    >
                    </app-number-form-control>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
}